import Color from '../Color.mjs'
import superMeta from '../_ARCH_CAT/metaArchCatNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.PURPLE,
    childType: 'LS',
    detailUrl: '/ProjectInfMap',
    name: '接口模型',
    type: 'CAT_LS',
}
